import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en_US from './en_US.json'
import fr_FR from './fr_FR.json'

export const defaultLocale = localStorage.getItem('defaultLocale') || 'fr_FR'

export const languages_trad = {
  "en_US": 'English',
  "fr_FR": 'Français'
}

export const languages_files = {
  en_US: en_US,
  fr_FR: fr_FR
}

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en_US',
  messages: Object.assign(languages_files)
})

export default i18n



// WEBPACK FOOTER //
// ./src/traductions/config.js